import { Dialog } from '@tamagui/dialog';

type ModalOverlayProps = {
  testID: string;
};

export const ModalOverlay = ({ testID }: ModalOverlayProps) => (
  <Dialog.Overlay
    key="overlay"
    testID={testID}
    // @ts-expect-error We have a custom backgroundColor prop
    backgroundColor="rgba(34, 39, 49, 0.50)"
    animateOnly={['opacity']}
    animation={[
      'quick',
      {
        opacity: {
          overshootClamping: true,
        },
      },
    ]}
    enterStyle={{ opacity: 0 }}
    exitStyle={{ opacity: 0 }}
  />
);
